/* eslint-disable no-shadow */
export enum CardType {
  /** 病院紹介希望条件カード */
  HospitalCondition = 'hospitalCondition',

  /** 病院紹介カード */
  HospitalIntroduction = 'hospitalIntroduction',

  /** 病院紹介（有料）カード */
  HospitalIntroductionsCharged = 'hospitalIntroductionsCharged',

  /** 問診カード */
  Questionnaire = 'inquiry',

  /** コンディションサーベイカード */
  RegularInterview = 'regularInterview',

  /** 通知カード */
  Notification = 'notification',

  /** チャットカード */
  Chat = 'chat',

  /** オンライン医療相談 */
  VideoMeeting = 'videoMeeting',

  /** オンライン医療相談（有料） */
  MedicalConsultationCharged = 'medicalConsultationCharged',

  /** チャット医療相談 */
  SpecialistChat = 'specialistChat',

  /** welcome カード */
  Welcome = 'welcome',

  /** welcome（問診あり） カード */
  WelcomeQuestionnaire = 'welcomeInquiry',

  /** オンライン診療カード */
  Telemedicine = 'telemedicine',

  /** 請求カード */
  Invoice = 'payment',

  /** 診療レポート */
  MedicalDevice = 'medical-device',

  /** コンテンツカード */
  Content = 'content',

  /** 健康診断カード */
  HealthCheck = 'health_check',
  // HealthCheckAnswerReCheck = 'report_remind',
  // HealthCheckChatSpace = 'health-check-chat-space',
  // HealthCheckRegisterAppointment = 'reserve_remind',
  // HealthCheckRegisterFinished = 're_exam_remind',
  // HealthCheckShowData = 'health-check-show-data',

  /** メンタルヘルスケアカード */
  Mental = 'mental',
  // MentalStart = 'mental-start',
  // MentalContents = 'mental-contents',
  // MentalRegularlyCheck = 'mental-regularly-check',
  // MentalStressCheck = 'mental-stress-check',

  // TODO: 5/26のデモまではdemo → 以降は変更してBot側と連携
  DeseaseCheck = 'demo',
}

// BEが返す問診の表題は改称前の旧名が残るため、表示名はカード種別から引く。
// 種別を持たない問診は表題に従うので、ここに載せない。
export const SURVEY_DISPLAY_TITLES: Readonly<Record<string, string>> = {
  [CardType.RegularInterview]: 'コンディションサーベイ',
  [CardType.WelcomeQuestionnaire]: 'コンディションサーベイ',
  [CardType.DeseaseCheck]: '定期症状・疾病チェック',
};

// 生活習慣ケアは提供終了。BEが過去分を返し続けるため、タイムライン取得時に落とす。
export const DISCONTINUED_CARD_TYPES: readonly string[] = [
  'lifestyle',
  'lifestyle-support',
];

export enum CardEventType {
  /**
   * [問診、病院紹介希望条件] 回答前
   * [請求] 医療者が請求済みの状態
  */
  Received = 'received',

  /** 回答後 */
  Answered = 'answered',

  /** 結果 */
  Results = 'results',

  /** 初回ログインカード 問診あり 医療者確認済 */
  Read = 'read',

  /** 削除済み */
  Deleted = 'deleted',

  /** 削除済み */
  Chat = 'chat',

  /** [オンライン医療相談、診療] 予約済み */
  Reserved = 'reserved',

  /** [オンライン医療相談、診療] 一時間前イベント */
  OneHourAgo = 'oneHourAgo',

  /** [オンライン医療相談、診療] 一日前イベント */
  OneDayAgo = 'oneDayAgo',

  /** [オンライン診療] オンライン診療中の状態 */
  Started = 'started',

  /** [オンライン診療] オンライン診療が終了し、未請求の状態 */
  Ended = 'ended',

  /** [オンライン診療] オンライン診療が終了し、請求済みの状態 */
  PaymentReceived = 'paymentReceived',

  /** [オンライン診療] オンライン診療が終了し、患者が決済完了の状態 */
  PaymentCompleted = 'paymentCompleted',

  /** [請求] 決済完了 */
  Completed = 'completed',

  /** 予約日を登録する（最初のページ） */
  ReserveRemind = 'reserveRemind',

  /** 健康診断は受診しましたか？ */
  ReportRemind = 'reportRemind',

  /** 予約日を登録する（2ページ目） */
  HealthCheckResult = 'result',

  /** 要再検査・要精密検査の該当がありますか？ */
  HealthCheckAnswerReCheck = 'reExamRemind',

  /** [健康診断] 受診リマインド1日前 */
  CheckupRemind = 'checkupRemind',

  /** [健康診断] 受診リマインド3日前 */
  CheckupRemind3DaysAgo = 'checkupRemind3DaysAgo',

  /** [健康診断] 受診リマインド2週間前 */
  CheckupRemind2WeeksAgo = 'checkupRemind2WeeksAgo',

  /** [健康診断] 受診確認 */
  CheckupConfirm = 'checkupConfirm',

  /** [健康診断] 結果受取確認 */
  ReportReceived = 'reportReceived',

  /** [健康診断] 予約日登録完了 */
  ReserveComplete = 'reserveComplete',
}

export enum StorageName {
  Timeline = 'timeline',

  UserTimeline = 'u_timeline',

  Toast = 'toast_id',
}

export enum ModuleName {
  VideoMeetings = 'videoMeetings',

  HospitalConditions = 'hospitalConditions',

  HospitalIntroductions = 'hospitalIntroductions',

  InquiryResults = 'inquiryResults',

  Enquetes = 'enquetes',

  MedicalDiagnosis = 'medicalDiagnosis',

  MedicalConsultationCharged = 'medicalConsultationCharged',

  SpecialistChat = 'specialistChat',

  HospitalIntroductionsCharged = 'hospitalIntroductionsCharged',

  Invoice = 'invoice',

  InHouseChat = 'inHouseChat',

  PatientChat = 'patientChat',
}
/* eslint-enable */
